import Vue from "vue"
import find from "lodash/find"
import { 
  MAX_NUMBER_OF_REVOLUTIONS,
  calculationDataToImperial
} from "./constants"

export default {
  // Turret
  updateIsImperial({commit, dispatch}, isImperialUpdate) {
    commit("updateIsImperial", isImperialUpdate);
    dispatch("fetchCalculation")
  },
  updateTurretHeight({commit}, newTurretHeight) {
    commit("updateTurretHeight", newTurretHeight)
  },
  updateTurretDiameter({commit}, newTurretDiameter) {
    commit("updateTurretDiameter", newTurretDiameter)
  },
  // Scope
  updateSightHeight({commit, dispatch}, newSightHeight) {
    commit("updateSightHeight", newSightHeight)
    dispatch("fetchCalculation")
  },
  updateClickUnit({commit}, newClickUnit) {
    commit("updateClickUnit", newClickUnit)
  },
  updateClickValue({commit, dispatch}, newClickValue) {
    commit("updateClickValue", newClickValue)
    dispatch("fetchCalculation")
  },
  updateClicksPerRotation({commit, dispatch}, newClicksPerRotation) {
    commit("updateClicksPerRotation", newClicksPerRotation)
    dispatch("fetchCalculation")
  },
  updateDirection({commit, dispatch}, newDirection) {
    commit("updateDirection", newDirection)
    dispatch("fetchCalculation")
  },
  updateNumberOfRevolutions({commit, dispatch}, newNumberOfRevolutions) {
    commit("updateNumberOfRevolutions", newNumberOfRevolutions)
    dispatch("fetchCalculation")
  },
  updateCurrentScope({commit, state, dispatch}, newScopeSlug) {
    if (!newScopeSlug || newScopeSlug === "other") {
      commit("updateCurrentScope", newScopeSlug)
      commit("updateMaxNumberOfRevolutions", MAX_NUMBER_OF_REVOLUTIONS)
      return
    }

    const newScope = find(state.scopes, {slug: newScopeSlug})

    commit("updateCurrentScope", newScope)
    commit("updateSightHeight", newScope.height)
    commit("updateClickUnit", newScope.unit)
    commit("updateClickValue", newScope["click_value"])
    commit("updateClicksPerRotation", newScope["clicks_per_rotation"])
    commit("updateDirection", newScope.rotation)
    commit("updateNumberOfRevolutions", newScope["number_of_revolutions"])
    commit("updateTurretHeight", newScope.turret.height)
    commit("updateTurretDiameter", newScope.turret.diameter)
    commit("updateMaxNumberOfRevolutions", newScope["number_of_revolutions"])

    dispatch("fetchCalculation")
  },
  updateCurrentScopeProductVariant({commit, getters}, newCurrentScopeProductVariantId) {
    let newCurrentScopeProductVariant = getters.permittedCurrentScope.turret.product_variants.find(variant => {
      return variant.id === newCurrentScopeProductVariantId
    })
    commit("updateCurrentScopeProductVariant", newCurrentScopeProductVariant)
  },
  // Firearm
  updateInitialVelocity({commit, dispatch}, newInitialVelocity) {
    commit("updateInitialVelocity", newInitialVelocity)
    dispatch("fetchCalculation")
  },
  updateZeroRange({commit, dispatch}, newZeroRange) {
    commit("updateZeroRange", newZeroRange)
    dispatch("fetchCalculation")
  },
  // Environment
  updateAltitude({commit, dispatch}, newAltitude) {
    commit("updateAltitude", newAltitude)
    dispatch("fetchCalculation")
  },
  updatePressure({commit, dispatch}, newPressure) {
    commit("updatePressure", newPressure)
    dispatch("fetchCalculation")
  },
  updateTemperature({commit, dispatch}, newTemperature) {
    commit("updateTemperature", newTemperature)
    dispatch("fetchCalculation")
  },
  updateHumidity({commit, dispatch}, newHumidity) {
    commit("updateHumidity", newHumidity)
    dispatch("fetchCalculation")
  },
  // Ammunition
  updateAmmunitionBrand({commit}, newBrand) {
    commit("updateAmmunitionBrand", newBrand)

    if (newBrand === "other") {
      commit("updateAmmunitionCaliber", "other")
      commit("updateCurrentAmmunition", "other")
    } else {
      commit("updateAmmunitionCaliber", null)
      commit("updateCurrentAmmunition", null)
    }
  },
  updateAmmunitionCaliber({commit}, newCaliber) {
    commit("updateAmmunitionCaliber", newCaliber)

    if (newCaliber === "other") {
      commit("updateCurrentAmmunition", "other")
    }
  },
  updateDragFunction({commit, dispatch}, newDragFunction) {
    commit("updateDragFunction", newDragFunction)
    dispatch("fetchCalculation")
  },
  updateDragCoefficient({commit, dispatch}, newDragCoefficient) {
    commit("updateDragCoefficient", newDragCoefficient)
    dispatch("fetchCalculation")
  },
  updateAmmunitionWeight({commit}, newAmmunitionWeight) {
    commit("updateAmmunitionWeight", newAmmunitionWeight)
  },
  updateCurrentAmmunition({commit, state, dispatch}, newCurrentAmmunitionSlug) {
    if (newCurrentAmmunitionSlug === null || newCurrentAmmunitionSlug === "other") {
      return commit("updateCurrentAmmunition", newCurrentAmmunitionSlug)
    }

    const newAmmunition = find(state.ammunitions, {slug: newCurrentAmmunitionSlug})

    commit("updateCurrentAmmunition", newAmmunition)
    commit("updateAmmunitionWeight", newAmmunition.weight)
    commit("updateDragFunction", newAmmunition["drag_function"])
    commit("updateDragCoefficient", newAmmunition["ballistic_coefficient"])

    dispatch("fetchCalculation")
  },
  // Customization
  fetchCalculation({state, getters, commit}) {
    commit("updateIsCalculationLoading", true)

    const params = {
      ballistic_calculator: {
        is_imperial: state.isImperial,
        max_moa: getters.maxMoa,
        click_unit: state.clickUnit,
        click_value: state.clickValue,
        drag_function: state.dragFunction,
        drag_coefficient: state.dragCoefficient,
        pressure: state.pressure,
        humidity: state.humidity,
        zero_range: state.zeroRange,
        sight_height: state.sightHeight,
        initial_velocity: state.initialVelocity,
        altitude: state.altitude,
        temperature: state.temperature,
      }
    }

    // Convert to imperial before calculation
    if (!state.isImperial) {
      params.ballistic_calculator = Object.assign({}, params.ballistic_calculator, calculationDataToImperial(params.ballistic_calculator));
    }

    return Vue.http.post("/api/calculator", params)
      .then((response) => {
        let newResults = []

        if (Array.isArray(response.body)) {
          newResults = response.body
        }

        commit("updateCalculationResults", newResults)
      })
      .finally(() => commit("updateIsCalculationLoading", false))
  }
}
